import { render, staticRenderFns } from "./CardMessage.vue?vue&type=template&id=9fedae00&scoped=true"
import script from "./CardMessage.vue?vue&type=script&lang=js"
export * from "./CardMessage.vue?vue&type=script&lang=js"
import style0 from "./CardMessage.vue?vue&type=style&index=0&id=9fedae00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fedae00",
  null
  
)

export default component.exports